import { createSelector } from 'reselect';
import { isDefined } from '@grandvisionhq/utils';
import { getStepsList, getCurrentStepIndex, stepsMapProp } from '../../state/selectors.internal.js';

const filterUniqueElements = (value, index, self)=>self.indexOf(value) === index
;
const getStepNames = createSelector(getStepsList, (steps)=>steps.map((s)=>s.name
    )
);
const getSubSteps = createSelector(getStepsList, (steps)=>steps.reduce((acc, step, i)=>step.isSubStep ? [
            ...acc,
            i
        ] : acc
    , [])
);
// the number of subSteps before each index, should be deducted from it
const getSubStepsSubtractor = createSelector(getSubSteps, (subSteps)=>(stepIndex)=>stepIndex - subSteps.filter((sub)=>sub < stepIndex
        ).length
);
// We disable all steps from the active step onwards, because we don't support jumping forward by clicking in the header
const getDisableSteps = createSelector(getStepNames, getCurrentStepIndex, getSubStepsSubtractor, (stepNames, currentStepIndex, subStepSubtractor)=>isDefined(currentStepIndex) ? stepNames.map((_, i)=>i
    ).slice(currentStepIndex + 1).map(subStepSubtractor).filter(filterUniqueElements) : []
);
const getSkipSteps = createSelector(getStepsList, getSubStepsSubtractor, (steps, subStepSubtractor)=>steps.reduce((acc, step, i)=>step.skip ? [
            ...acc,
            i
        ] : acc
    , []).map(subStepSubtractor).filter(filterUniqueElements)
);
const getActiveStepIndex = createSelector(getCurrentStepIndex, getSubSteps, getSubStepsSubtractor, (currentStepIndex, subSteps, subStepSubtractor)=>{
    if (!isDefined(currentStepIndex)) {
        return currentStepIndex;
    }
    // if current step is a subStep, we will return it's parent Index
    if (subSteps.includes(currentStepIndex)) {
        let parentIndex = currentStepIndex - 1;
        while(subSteps.includes(parentIndex) && parentIndex >= 0){
            parentIndex -= 1;
        }
        return subStepSubtractor(parentIndex);
    }
    // otherwise, like other indices we will deduct the number of subSteps behind it
    return subStepSubtractor(currentStepIndex);
});
const getEnabledStepLabels = createSelector(stepsMapProp, getStepsList, getSubSteps, (stepsMap, steps, subSteps)=>{
    return steps// removing subStep from the labels
    .filter((_, index)=>!subSteps.includes(index)
    ).reduce((m, { name  })=>{
        const stepData = stepsMap[name];
        return (stepData === null || stepData === void 0 ? void 0 : stepData.labelKeys.stepIndicatorTitle) ? [
            ...m,
            stepData.labelKeys.stepIndicatorTitle
        ] : m;
    }, []);
});
const getStepWizardData = createSelector(getActiveStepIndex, getEnabledStepLabels, getSkipSteps, getDisableSteps, (currentStepIndex, enabledStepLabels, skipSteps, disableSteps)=>({
        skipSteps,
        disableSteps,
        currentStepIndex,
        enabledStepLabels
    })
);

export { getStepWizardData };
//# sourceMappingURL=selectors.internal.js.map
